import {LocaleDictionaryCalendar} from "../../interface/calendar";

export const calendar: LocaleDictionaryCalendar = {
    today : 'Today',
    title : 'Calendar',
    weekDays : ['Mo', 'Tu', 'We', 'Th' , 'Fr', 'Sa', 'Su']
};




